/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Petty_Acidic_Herring_NailInputs */

const fr_petty_acidic_herring_nail = /** @type {(inputs: Petty_Acidic_Herring_NailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'email doit être valide`)
};

/**

* @param {Petty_Acidic_Herring_NailInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const petty_acidic_herring_nail = /** @type {((inputs?: Petty_Acidic_Herring_NailInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Petty_Acidic_Herring_NailInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_petty_acidic_herring_nail(inputs)
});